import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Typography,
  Paper,
  Box,
  Alert,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { apiFetch, API_BASE } from "./utils/apiClient";
import { toDateSafe } from "./utils/toDateSafe";
import { hasPermission } from "./utils/userProfile";

const StoryVideosDashboard = () => {
  const [videos, setVideos] = useState([]);
  const [search, setSearch] = useState("");
  const username = localStorage.getItem("username");

  const allowedUsers = ["admin", "maysa@123", "Baneen@123"];

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await apiFetch(`${API_BASE}/story-videos`);
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.error || "فشل تحميل فيديوهات الرسم");
        }

        data.sort((a, b) => {
          const dateB = toDateSafe(b.uploadedAt)?.getTime() || 0;
          const dateA = toDateSafe(a.uploadedAt)?.getTime() || 0;
          return dateB - dateA;
        });

        setVideos(data);
      } catch (error) {
        console.error("❌ خطأ في جلب فيديوات الرسم:", error);
      }
    };

    fetchVideos();
  }, []);

  const filteredVideos = useMemo(() => {
    return videos.filter((item) => {
      const customer = item.customerName || "";
      return customer.toLowerCase().includes(search.toLowerCase());
    });
  }, [videos, search]);

  // + أي حساب ممنوح بوكس "فديوات الرسم" من واجهة صلاحية المستخدمين
  if (!allowedUsers.includes(username) && !hasPermission("drawingVideos")) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Alert severity="error">ليس لديك صلاحية لعرض هذه الصفحة</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 6 }} dir="rtl">
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", mb: 3, textAlign: "right", color: "#333" }}
      >
        🎬 أرشيف فيديوهات الرسم
      </Typography>

      <Box sx={{ mb: 4 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="بحث سريع باسم الطلب..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ bgcolor: "#fff", borderRadius: 1 }}
        />
      </Box>

      {filteredVideos.length === 0 ? (
        <Alert severity="info">لا توجد فيديوهات.</Alert>
      ) : (
        <Grid container spacing={1.5}>
          {filteredVideos.map((item, index) => (
            <Grid item xs={6} sm={4} md={3} lg={2} key={item.id}>
              <Paper
                elevation={0}
                sx={{
                  p: 1,
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  border: "1px solid #e0e0e0",
                  transition: "0.2s",
                  "&:hover": { bgcolor: "#f1f3f4", borderColor: "#d0d0d0" },
                }}
              >
                {/* منطقة عرض الفيديو (Thumbnail) */}
                <Box
                  onClick={() => window.open(item.videoLinks?.[0], "_blank")}
                  sx={{
                    width: "100%",
                    aspectRatio: "1/1",
                    bgcolor: "#000",
                    borderRadius: 1,
                    overflow: "hidden",
                    cursor: "pointer",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {/* وسم فيديو صامت وبدون تحكم ليظهر كـ Thumbnail فقط */}
                  <video
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    preload="metadata"
                  >
                    <source src={`${item.videoLinks?.[0]}#t=0.5`} type="video/mp4" />
                  </video>
                  
                  {/* رقم التسلسل في الزاوية */}
                  <Typography
                    variant="caption"
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      bgcolor: "rgba(0,0,0,0.5)",
                      color: "#fff",
                      px: 0.6,
                      borderRadius: 0.5,
                      fontSize: "9px"
                    }}
                  >
                    {filteredVideos.length - index}
                  </Typography>
                </Box>

                {/* الاسم وزر النسخ */}
                <Box sx={{ display: "flex", alignItems: "center", mt: 1, gap: 0.5 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 500,
                      fontSize: "12px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flex: 1,
                      textAlign: "right",
                      color: "#3c4043"
                    }}
                  >
                    {item.customerName || "طلب بدون اسم"}
                  </Typography>

                  <IconButton 
                    size="small" 
                    onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(item.videoLinks?.[0]);
                     
                    }}
                    sx={{ p: 0.2 }}
                  >
                    <ContentCopyIcon sx={{ fontSize: 14, color: "#5f6368" }} />
                  </IconButton>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default StoryVideosDashboard;